import {
  isDbOrGQLNotFoundError,
  PossibleNotFoundError,
} from "./isDbOrGQLNotFoundError";
import { NotFoundError } from "./KazooError";

/**
 * Helper function that accepts an error from a graphql call and throws NotFound if it is already a NotFound error or if it contains the phrase "not found"
 */
export function throwNotFoundIfAppropriate(error: PossibleNotFoundError) {
  if (isDbOrGQLNotFoundError(error)) {
    throw new NotFoundError(error.message);
  }
  throw error;
}
